import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Button from "../../AdminModule/Dashboard/AdminDashboard/Button";
import ReactStars from "react-rating-stars-component";
import "./styles.scss";
import swal from "sweetalert";
import { makeStyles } from "@material-ui/core/styles";
import TextareaField from "../TextAreaField";
import Select from "react-select";
import { postUploadProgressReport } from "../../AdminModule/Dashboard/StartupDashboard/dependencies/action";
const useStyles = makeStyles((theme) => ({
  input: {
    backgroundColor: "white",
    padding: "0.5px 0px",
  },
}));
function UploadProgressReportModal(props) {
  const {postUploadProgressReport} = props;
  const [ratingData, setRatingData] = useState(0);
  const classes = useStyles();
  const [changeStatusData, setChangeStatusData] = useState("");
  const [newJobs, setNewJobs] = useState("");
  const [revenueGenerated, setRevenueGenerated] = useState("");
  const [investmentRaised, setInvestmentRaised] = useState("");
  const [awardsData, setAwardsData] = useState("");
  const progressReport =JSON.parse(localStorage.getItem("ProgressReport"));
  useEffect(()=>{
    setAwardsData(progressReport?.awards);
    setRevenueGenerated(progressReport?.revenueGenerated);
    setInvestmentRaised(progressReport?.investmentRaised);
    setChangeStatusData(progressReport?.stage);
    setNewJobs(progressReport?.jobsCreated);
    
  },[])
  const handleSubmit = () =>{
    
    let params ={
      stage: changeStatusData,
      jobsCreated: newJobs,
      revenueGenerated: revenueGenerated,
      investmentRaised: investmentRaised,
      awards: awardsData,
      startupId:JSON.parse(localStorage.getItem("SavedLoggedInData")).id
    }
    let Localparams ={
      stage: changeStatusData,
      jobsCreated: newJobs,
      revenueGenerated: revenueGenerated,
      investmentRaised: investmentRaised,
      awards: awardsData,
    }
    props.parentData(params)
    postUploadProgressReport(params)
    localStorage.setItem("ProgressReport", JSON.stringify(Localparams));
    swal({
      title: "Thank You",
      text: `Progress Report Submitted Successfully`,
      icon: "success",
      // timer: 1500,
      // buttons: false,
    }).then(function(){ 
      props.setModalVisibility(false)
      })
      // setChangeStatusData("");
      // setNewJobs("");
      // setRevenueGenerated("");
      // setInvestmentRaised("");
      // setAwardsData("");
  }
  
  const changeStatus = [{}];
  changeStatus.push(
    {
      value: "Ideation",
      label: "Ideation",
    },
    {
      value: "Validation",
      label: "Validation",
    },
    {
      value: "Early traction",
      label: "Early traction",
    },
    {
      value: "Scalling",
      label: "Scalling",
    }
  );
  const customStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "white",
      minHeight: "45px",
      color: "#333",
      fontSize:"16px",
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isSelected
          ? "#b499c7"
          : isFocused
          ? "#e4d7ee"
          : "white",
        color: isSelected ? "white" : "black",
        cursor: isDisabled ? "not-allowed" : "default",
      };
    },
      menu: (base) => ({
    ...base,
    width: "max-content",
    minWidth: "100%",
    fontSize:"14px"
})
  };
  const handleClose = () => {
    props.setModalVisibility(false);
  };
  const ratingChanged = (newRating) => {
    
    setRatingData(newRating);
  };

  const secondExample = {
    size: 35,
    count: 5,
    isHalf: false,
    value: 0,
    color: "lightgray",
    activeColor: "orange",
    onChange: (newValue) => {
      
    },
  };
 
  return (
    <>
      <div className="modal-dialog modal-dialog-centered">
        <Modal
          size="lg"
          show={props.modalVisibility}
          onHide={() => props.setModalVisibility(false)}
          aria-labelledby="example-modal-sizes-title-lg"
          style={{ borderRadius: "7px" }}
        >
          <Modal.Header className="d-flex ">
            <Modal.Title className="modalHeading">
              UPLOAD PROGRESS REPORT
            </Modal.Title>
            <div className="newuserTooltip">
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={handleClose}
            />
             <span className="tooltiptext  close-window" style={{left:"-130px",top:"2px",padding:"4px 12px",width:"130px"}}>Close Window</span>
        </div>
          </Modal.Header>
          <Modal.Body>
            {
              
            }
            <div className="session-detailsModal">
              <div className="feedback-session2">
                <div className="row pb-4 heightModalFix">
                  <div className="col col-lg-1 col-md-1 col-sm-12 col-2 numdata d-flex justify-content-center">
                    1
                  </div>
                  <div className="col col-lg-4 col-md-5 col-sm-10 col-10 feedback-headdding ">
                    CHANGE STATUS
                  </div>
                  <div 
                    style={{ textAlign: "left", fontFamily: "Montserrat" }}
                    className="col col-lg-7 col-md-6 col-sm-12  col-12 fixmodalmargindata"
                  >
                    {
                      
                    }
                    <Select
                      options={changeStatus}
                      styles={customStyles}
                      placeholder={changeStatusData !== "" ? changeStatusData : "Select the Status"}
                      onChange={(e) => {
                        setChangeStatusData(e.label);
                      }}

                      // value={awardsData}
                    />
                  </div>
                </div>
                <div className="row pb-4 ">
                  <div className="col col-lg-1 col-md-1 col-sm-2 col-2 d-flex justify-content-center">
                    2
                  </div>
                  <div className="col col-lg-4 col-md-5 col-sm-10 col-10 feedback-headdding">
                    NEW JOBS CREATED
                  </div>
                  <div className="col col-lg-7 col-md-6 col-sm-12  col-12 fixmodalmargindata">
                  <input
                    type="number"
                    class="form-control"
                    id="exampleFormControlInput1"
                    placeholder="Enter new jobs created"
                    onChange={(e) => {
                        setNewJobs(e.target.value);
                      }}
                      value={newJobs}
                  />
                </div>
                </div>
                <div className="row pb-4 ">
                  <div className="col col-lg-1 col-md-1 col-sm-2 col-2 d-flex justify-content-center">
                    3
                  </div>
                  <div className="col col-lg-4 col-md-5 col-sm-10 col-10 feedback-headdding ">
                    REVENUE GENERATED (INR)
                  </div>
                  <div className="col col-lg-7 col-md-6 col-sm-12  col-12 fixmodalmargindata">
                  <input
                    type="number"
                    class="form-control"
                    id="exampleFormControlInput1"
                    placeholder="Enter revenue generated"
                    onChange={(e) => {
                        setRevenueGenerated(e.target.value);
                      }}
                      value={revenueGenerated}
                  />
                </div>
                </div>
                <div className="row pb-4 ">
                  <div className="col col-lg-1 col-md-1 col-sm-2 col-2 d-flex justify-content-center">
                    4
                  </div>
                  <div className="col col-lg-4 col-md-5 col-sm-10 col-10 feedback-headdding ">
                    NEW INVESTMENT RAISED (INR)
                  </div>
                  <div className="col col-lg-7 col-md-6 col-sm-12  col-12 fixmodalmargindata">
                  <input
                    type="number"
                    class="form-control"
                    id="exampleFormControlInput1"
                    placeholder="Enter investment raised"
                    onChange={(e) => {
                        setInvestmentRaised(e.target.value);
                      }}
                                            value={investmentRaised}

                  />
                </div>
                </div>
                <div className="row pb-4 ">
                  <div className="col col-lg-1 col-md-1 col-sm-12 col-2 numdata d-flex justify-content-center">
                    5
                  </div>
                  <div className="col col-lg-4 col-md-5 col-sm-10 col-10 feedback-headdding ">
                    AWARDS AND RECOGNITION
                  </div>
                  <div className="col col-lg-7 col-md-6 col-sm-12  col-12 fixmodalmargindata">
                  <input
                    type="email"
                    class="form-control"
                    id="exampleFormControlInput1"
                    placeholder={awardsData !== "" ? awardsData : "Enter awards and recognition"}
                    onChange={(e) => {
                        setAwardsData(e.target.value);
                      }}
                      value={awardsData}
                  />
                </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-center">
            <div className="d-flex justify-between feedBackFooterFix">
              <div>
                <Button
                  onClick={handleClose}
                  text="BACK"
                  className="modalButton3 doc-upload"
                ></Button>
              </div>
              <div>
                <Button
                  onClick={handleSubmit}
                  text="SUBMIT"
                  className="modalButton3 doc-uploadnext"
                ></Button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
  };
};

export default connect(mapStateToProps, { postUploadProgressReport })(
  withRouter(UploadProgressReportModal)
);
